(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('textprocessing', {
      restrict: 'E',
      bindings: {},
      templateUrl: 'vcpatdocs/textprocesssing-smartcomponent.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Patdocs', 'ClientHelper', 'Config', 'Rlog', '$timeout', 'PrintHelper', 'Drug', '$window',
        function ($log, Patdocs, ClientHelper, Config, Rlog, $timeout, PrintHelper, Drug, $window) {
          let vm = this;

          vm.savePatient = savePatient;
          vm.clearPatient = clearPatient;

          vm.saveDoctor = saveDoctor;
          vm.clearDoctor = clearDoctor;

          vm.add = add;
          vm.cancel = cancel;
          vm.print = print;
          vm.preview = preview;

          vm.options = {updateOn: 'default blur', debounce: {default: 20000, blur: 0}};
          vm.tinymceOptions = {
            selector: 'textarea',
            skin: 'lightgray',
            theme: 'modern',
            resize: true,
            width: '100%',
            height: 300,
            entity_encoding: 'raw',
            plugins: 'link searchreplace table spellchecker print preview template',
            menubar: 'file edit insert view format table tools',
            toolbar: 'undo redo | formatselect fontsizeselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent'
          };

          vm.$onInit = function () {
            vm.mode = 'patient';
            inittextdoc();
          }; // $onInit()

          // reset textdoc form
          function inittextdoc() {
            vm.textdoc = {};
            vm.textdoc.type = 'textdoc';
            vm.textdoc.fdate = moment().locale('de-at').format('ll');
          }

          // save patient data
          function savePatient(client, mode) {
            $log.debug('patient in savePatient: ', client, mode);
            delete vm.textdoc.patient;
            vm.patient = client;
            vm.patientid = client._id;
            vm.textdoc.patient = {};
            vm.textdoc.patient.fname = vm.patient.primarycontact.firstname + ' ' + vm.patient.primarycontact.lastname;
            vm.textdoc.patient.svdata = vm.patient.svdata;
            vm.textdoc.patient.diagnoses = vm.patient.diagnoses;
            vm.textdoc.patient.risk = vm.patient.risk;
            vm.textdoc.patient.notes = vm.patient.notes;
            vm.textdoc.patientid = vm.patient._id;
            vm.textdoc.patient._id = vm.patient._id;
            vm.textdoc.patient.primarycontact = vm.patient.primarycontact;
            $log.debug('textdoc contents: ', vm.textdoc);
          }

          // clear timeslip patient
          function clearPatient() {
            delete vm.textdoc.patient;
            delete vm.textdoc.patientid;
          }

          // save referral doctor
          function saveDoctor(doctor) {
            delete vm.textdoc.to;
            vm.textdoc.doctor = doctor;
          }

          // clear referral doctor
          function clearDoctor() {
            delete vm.textdoc.doctor;
          }

          function add() {
            Patdocs.$create(vm.textdoc).$then(function () {
              vm.saved = true;
              vm.savefailed = false;
              vm.canceled = false;
              inittextdoc();
              $timeout(function () {
                vm.saved = false;
              }, 3000);
            });
          }

          function cancel() {
            vm.saved = false;
            vm.canceled = true;
            vm.savefailed = false;
            inittextdoc();
            $timeout(function () {
              vm.canceled = false;
            }, 3000);
          }

          function print() {
            vm.textdoc.xhtml = '<xhtml>' + vm.xhtml.toString() + '</xhtml>';
            $log.debug('vm.newtext.xhtml: ', vm.textdoc.xhtml);

            if (vm.textdoc.getdrugs === true) {
              Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
                vm.textdoc.patdrugs = drugs[0];
                printhandler();
              }, function (err) {
                $log.error('Patient drugs acquisition failed: ', err);
              });
            } else {
              printhandler();
            }
          }


          function preview() {
            $log.debug('preview called');
            vm.textdoc.xhtml = '<xhtml>' + vm.xhtml.toString() + '</xhtml>';
            $log.debug('vm.newtext.xhtml: ', vm.textdoc.xhtml);

            if (vm.textdoc.getdrugs === true) {
              Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
                vm.textdoc.patdrugs = drugs[0];
                previewhandler();
              }, function (err) {
                $log.error('Patient drugs acquisition failed: ', err);
              });
            } else {
              previewhandler();
            }
          }


          function printhandler() {
            Patdocs.$create(vm.textdoc).$then(function (textdoc) {
              vm.saved = true;
              vm.savefailed = false;
              vm.canceled = false;
              $timeout(function () {
                vm.saved = false;
              }, 3000);
              $log.debug('timelip returned: ', textdoc);
              PrintHelper.jsonPrint(vm.patientid, 'freeform', textdoc).then(function () {
                inittextdoc();
                $log.debug('printing textdoc succeeded');
                vm.printed = true;
                $timeout(function () {
                  delete vm.printed;
                }, 3000);
              }, function (err) {
                vm.printed = false;
                $timeout(function () {
                  delete vm.printed;
                }, 3000);
                $log.error('printing textdoc failed: ', err);
              });
            });
          }


          function previewhandler() {
            Patdocs.$create(vm.textdoc).$then(function (textdoc) {
              vm.saved = true;
              vm.savefailed = false;
              vm.canceled = false;
              $timeout(function () {
                vm.saved = false;
              }, 3000);

              // using fetch because restmod screwed with the pdf encoding
              fetch(`/routes/fop/plainjson/false/false/${vm.patientid}/freeform`, {
                method: 'POST',
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                  'Content-Type': 'application/json'
                  // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: 'follow', // manual, *follow, error
                referrer: 'no-referrer', // no-referrer, *client
                body: JSON.stringify(textdoc)
              })
                .then(response => {
                  if (response.ok) {
                    return response.blob();
                  }
                })
                .then(blob => {
                  $log.debug('previewing textdoc succeeded: ', blob);
                  let previewBlob = new Blob([blob], {type: "application/pdf"});
                  let url = $window.URL || $window.webkitURL;
                  vm.previewUrl = url.createObjectURL(previewBlob);
                  $log.debug('previewUrl: ', vm.previewUrl);
                  $window.open(vm.previewUrl, '_blank');
                })
                .catch(err => {
                  $log.error('Failed to generate freeform text preview; ', err);
                });

            });
          }

        }
      ] // controller
    }); // component

// klammerfriedhof
}());
